import { Component, Output } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { UsersService } from '../services/users.service';
import { ResponseTable } from '../models/ResponseTable';
import { LoaderComponent } from '../utils/loader/loader.component';
import { CommonModule } from '@angular/common';
import { UserModalComponent } from '../utils/user-modal/user-modal.component';
import { DevicesService } from '../services/devices.service';
import { DeviceModalComponent } from "../utils/device-modal/device-modal.component";
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../theme.service';
import { LoginUserModel } from '../models/loginUserModel';
import { ToastService } from '../services/toast.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { AvatarComponent } from '../utils/avatar/avatar.component';

@Component({
    selector: 'app-users',
    imports: [
        LoaderComponent, CommonModule, FormsModule,
        UserModalComponent, DeviceModalComponent,
        AvatarComponent, TableModule, ButtonModule, InputTextModule,
        IconFieldModule, InputIconModule, DialogModule, TooltipModule
    ],
    templateUrl: './users.component.html',
    styleUrl: './users.component.scss'
})
export class UsersComponent {

  data: LoginUserModel;
  response: ResponseTable = new ResponseTable();
  loading = false;
  tableButtons: any[] = [];
  showModal = false;
  msgModal = 'Datos del Usuario';
  isNewUser = false;
  userData: any;
  showModalDevice = false;
  deviceData: any[]=[];
  userId: number = 0;
  cardsClient: any[]=[]
  openNotification :boolean= false
  notification :any
  globalFilter = '';
  showDeleteConfirm = false;
  deleteTarget: any = null;
  showResetConfirm = false;
  resetTarget: any = null;

  isActive(user: any) { return new Date(user.validFrom) <= new Date(); }

  get tableColumns(): {key: string, header: string}[] {
    if (!this.response.headers?.length) return [];
    return this.response.headers
      .filter((h: any) => h.visible !== false && h.textHeader)
      .map((h: any) => ({ key: h.key, header: h.textHeader }));
  }

  confirmDeleteUser(user: any) { this.deleteTarget = user; this.showDeleteConfirm = true; }

  doDeleteUser() { this.showDeleteConfirm = false; this.deleteUser(this.deleteTarget); }

  constructor(private service: UsersService,private deviceService:DevicesService, private titleService:Title, private themeService:ThemeService, private toastSrv: ToastService
      
  ) {
    this.titleService.setTitle("Usuarios");
    this.themeService.setTitle("Usuarios");
 
    this.data = JSON.parse(localStorage.getItem('data')!); 

  

    if( this.data.UserType=='Modify'){
      this.tableButtons =[
        {
          text: 'Asignar',
          action: (event: any) => this.selectDevices(event),
          icon: undefined,
          hasIcon: true,
          color: '',
          showText: false,
        }
      ]
    }else if(this.data.UserType=='Administrator'){

      this.tableButtons =[
        {
          text: 'Editar',
          action: (event: any) => this.showInfoUser(event),
          icon: undefined ,
          hasIcon: true,
          color: '',
          showText: false,      
  
        },
        {
          text: 'Eliminar',
          action: (event: any) => this.deleteUser(event),
        icon: undefined ,
          hasIcon: true,
          color: '',
          showText: false,
        },
        {
          text: 'Contraseña',
          action: (event: any) => this.sendResetLink(event),
         icon: undefined ,
          hasIcon: true,
          color: '',
          showText: false,
        },
        {
          text: 'Asignar',
          action: (event: any) => this.selectDevices(event),
         icon: undefined ,
          hasIcon: true,
          color: '',
          showText: false,
        },
         {
          text: 'Reenviar activación',
          action: (event: any) => this.resend(event),
          icon: undefined ,
          hasIcon: true,
          color: '',
          showText: false,
        },
        { 
          text: 'Activar',
          action: (event: any) => this.activateUser(event),
          icon: undefined ,
          hasIcon: true,
          color: '',
          showText: false,

        }
       
      ];
    }else{
      this.tableButtons=[];
    }
   
  }

  ngOnInit(): void {
    this.getUser();
    
  }

  showInfoUser(data: any) {
    this.userData = data;
    this.userData.clientNumber = this.data.Client_number;
    this.isNewUser = false;
    this.showModal = true;
  }


  getUser(): void {
    this.loading = true;
    this.service.getUsers(this.data.Client_number).subscribe({
      next: (data: ResponseTable) => {
        this.response = data;
        this.response.items = this.response.items.map((item: any) => {
          return {
            ...item,
            disableButton: false,
            buttons:this.setButtons(item), 
            colors:['','','','','',item.canActivate?'':'#b6adb2']
          };
        });       
        this.loadDevices();
      },
      error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: err.message });
        this.loading = false;
      },
    });
  }

  loadDevices() {
    this.deviceService
      .loadDevices(this.data.Client_number, this.data.User_id, '',true)
      .subscribe({
        next: (resp: any) => {
          //this.cardsClient = resp;
          this.cardsClient = resp.filter((item:any) => {
            return item.isMaster != 1 && item.deviceType != "M" && !item.description.toUpperCase().includes("MAESTRA")
          });
          this.loading = false;        
        },
        error: (err: any) => {
          this.toastSrv.add({ type: 'error', message: err.message });
          this.loading = false;
        }
      });
  }


  deleteUser(data: any): void {
    this.loading = true;
    data.clientNumber = this.data.Client_number;
    this.service.deleteUser(data).subscribe({
      next: (responsedata: any) => {
        if (responsedata.isSuccess ) {
          this.response.items = this.response.items.filter(
            (user: any) => user.userId !== data.userId
          );

          this.response.items = this.response.items.map((item: any) => {
            return {
              ...item,
              disableButton: false,
              buttons:this.setButtons(item) 
            };
          });
          this.onConfirm();
          this.toastSrv.add({ type: 'success', message: 'Se eliminó usuario correctamente' });
        } else {
          this.toastSrv.add({ type: 'error', message: responsedata.message });
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: err.error.error });
        this.loading = false;
      },
    });
  }

  onConfirm() {
    this.showModal = false;
    this.getUser();
  }

  onCancel() {
    this.showModal = false;
  }

  onToastSuccess(msg: string) {
    this.toastSrv.add({ type: 'success', message: msg });
  }

  newUser() {
    this.userData = new Object();
    this.userData.clientNumber = this.data.Client_number;
    this.userData.userId = 0;
    this.isNewUser = true;
    this.showModal = true;
  }

  selectDevices(data: any) {
    this.userId = data.userId
    this.showDevices(this.data.Client_id,data.userId)
  }


  saveDevices(data: any) {   
    this.service.saveDevicesbyUser(data).subscribe({
      next: (resp: any) => {
        this.showModalDevice=false
      },
      error: (err: any) => {
        this.showModalDevice=false
        this.toastSrv.add({ type: 'error', message: err.error.error });
      },
      complete: () => {},
    });
  }

  deleteDevices(data: any) {
    this.service.deleteDevicesbyUser(data).subscribe({
      next: (resp: any) => {      
          this.showModalDevice=false        
      },
      error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: err.error.error });
      },
      complete: () => {},
    });
  }

  showDevices(clientId:number, userId:string) {
    this.loading= true;
    this.service.getDevicesbyUser(clientId, userId).subscribe({
      next: (resp: any) => {
        if (resp.message === '') {
          this.loading= false;
          this.showModalDevice = true;
          this.deviceData= resp.response;
        } else {          
        }
      },
      error: (err: any) => {
        this.loading= false;
        this.toastSrv.add({ type: 'error', message: err.error.error });
      },
      complete: () => {},
    });
  }

  updateDevices(data:any){
    
    const savefilter = data.filter((item:any) => item.deviceType === '2').map((item:any) => item.cardId);
    const deletefilter = data.filter((item:any) => item.deviceType === '4').map((item:any) => item.cardId);
    if (savefilter.length > 0) {
        const saveData = {clientNumber:this.data.Client_number,userId:this.userId,cardId:savefilter};
        this.saveDevices(saveData);
    }    
    if (deletefilter.length > 0) {
      const deleteData = {clientNumber:this.data.Client_number, userId:this.userId,cardId:deletefilter}
      this.deleteDevices(deleteData)
    } 
  }

  setButtons(item: any) {
    if (new Date(item.validFrom)<=new Date()) {    
      if( this.data.UserType=='Modify'){
        return [
          'Asignar'
        ]
      }
      else if(item.accessType==='Modificación'&& this.data.UserType=='Administrator'){
        return [           
          'Editar',
          'Eliminar',
          'Contraseña',
          'Asignar',
         
          'Activar'   
          
         
        ]
      }
      else if(this.data.UserType=='Administrator'){
        return [         
          'Editar',
          'Eliminar',
          'Contraseña',
          'Asignar'    
        ]
      }
      
      else{
        return []
      }
     
    } else {
     if(this.data.UserType=='Administrator'){
        return [
          'Editar',
          'Eliminar',
          'Contraseña',
          'Reenviar'

         
        ]
      }else{
      return [];
    }
    }
  }

  activateUser(data: any) {    
    const isValid=!data.canActivate 
    this.service.ActivateUser(this.data.Client_number,data.userId,isValid).subscribe({
      next:(value :any)=> {
        if(value){
          data.canActivate= isValid;
        }
        else{
          data.canActivate = false;
        }
      },
      error:(err: any)=> {
        data.canActivate = false;
      },
      complete:() => {
        data.colors[5]=data.canActivate?'':'#b6adb2'
        this.notification={
            title:(data.canActivate?'Se activó ':'Se desactivó ')+'para aprobar conductores.' ,
            description:''           
        }
        this.openNotification=true;         
            
      },
    })
  }


  confirmSendResetLink(user: any) {
    this.resetTarget = user;
    this.showResetConfirm = true;
  }

  doSendResetLink() {
    this.showResetConfirm = false;
    this.sendResetLink(this.resetTarget);
  }

  sendResetLink(event: any) {
    this.loading = true;
    this.service.sendResetLink(event.userId).subscribe({
      next: (resp: any) => {
        this.toastSrv.add({ type: resp.isSuccess ? 'success' : 'error', message: resp.message });
      },
      error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: 'Hubo un problema al enviar el correo de restauración.' });
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  resend(event:any){
    this.loading = true;
    event.clientNumber=this.data.Client_number; 
    event.accessType = this.GetUserType(event.accessType);
    this.service.resendEmail(event).subscribe({
      next: (resp:any) => {
        this.toastSrv.add({ type: 'success', message: 'Se ha reenviado el correo de activación.' });
      },
      error: (err:any) => {
        console.error(err); 
        this.toastSrv.add({ type: 'error', message: 'Hubo un problema al reenviar el correo de activación.' });
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  GetUserType(accessType: string): number {
    if (accessType == 'Consulta') {
      return 0;
    }
    if (accessType == 'Revisión') {
      return 2;
    }
    if (accessType == 'Modificación') {
      return 1;
    } else accessType == 'Finanzas';
    {
      return 3;
    }
  }

}

